import { mesaColorNames } from '@/src/common/theme'
import { Stack } from 'expo-router'
import { Platform, View } from 'react-native'

export const unstable_settings = {
  // Ensure that reloading on `/modal` keeps a back button present.
  initialRouteName: 'index',
}

type ExpoStackProps = React.ComponentProps<typeof Stack>

export default function MortgageEarnLayout({ ExpoStackProps }: { ExpoStackProps: ExpoStackProps }) {
  return (
    <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center' }}>
      <LayoutNav ExpoStackProps={ExpoStackProps} />
    </View>
  )
}

function LayoutNav({ ExpoStackProps }: { ExpoStackProps: ExpoStackProps }) {
  return (
    <Stack
      {...ExpoStackProps}
      screenOptions={{
        headerShown: false,
        statusBarStyle: Platform.OS === 'android' ? 'dark' : undefined,
        contentStyle: { backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'] },
        statusBarBackgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="earn-on-mortgage" />
      <Stack.Screen name="earn-on-mortgage-document-upload" />
      <Stack.Screen name="mortgage" />
    </Stack>
  )
}
